import http from '@/libs/axios'

export function getSections(params) {
  return http.get('apartments/section/', {
    params
  })
}

export function getSectionsByApartment(id) {
  return http({
    method: 'GET',
    url: `apartments/${id}/sections/`,
  })
}

export function getSectionsByApartmentForSelect(id) {
  return http({
    method: 'GET',
    url: `apartments/${id}/sections/`,
  })
}

export function updateSection(data) {
  return http.patch(`apartments/section/${data.id}/`, data)
}
export function craeteSection(data) {
  return http.post('apartments/section/', data)
}

export function dublicateSection(data) {
  return http.post('flats/duplicate_create/', data)
}